import React from "react";
import PropTypes from "prop-types";
import "./ClusterMarker.css";

/**
 * ClusterMarker Component
 *
 * Displays a small, subtle cluster indicator showing the number of restaurants.
 * Clicking zooms in to spread the cluster.
 */
const ClusterMarker = ({
  cluster,
  onClusterClick,
}) => {
  const handleClick = () => {
    if (onClusterClick) {
      onClusterClick(cluster);
    }
  };

  // Determine size class based on count
  const getSizeClass = (count) => {
    if (count >= 10) return "cluster-large";
    if (count >= 5) return "cluster-medium";
    return "";
  };

  return (
    <div
      className={`cluster-marker ${getSizeClass(cluster.count)}`}
      onClick={handleClick}
      title={`${cluster.count} restaurants - click to zoom in`}
    >
      <span className="cluster-marker-count">{cluster.count}</span>
    </div>
  );
};

ClusterMarker.propTypes = {
  cluster: PropTypes.shape({
    count: PropTypes.number.isRequired,
    avgLeafCount: PropTypes.number.isRequired,
    center: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }).isRequired,
    bounds: PropTypes.object.isRequired,
    restaurants: PropTypes.array.isRequired,
  }).isRequired,
  onClusterClick: PropTypes.func,
  mapHeading: PropTypes.number,
};

export default ClusterMarker;
